import { createIcon } from '../createIcon.tsx';

export const ChevronDownIcon = createIcon('ChevronDownIcon', <polyline points="6 9 12 15 18 9" />);
